import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const KeypadCallModal = ({
  title,
  children,
  onClose,
  size = "lg",
  noHeader = false,
  noBorder = false,
  className = "",
  zIndex = "z-[99999999]",
  bodyStyleObject = {},
}) => {
  const sizeMap = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    full: "w-full h-full",
  };

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-[#0000008f] bg-opacity-50 z-50`}
    >
      <div
        className={`bg-white rounded shadow-lg w-full !max-w-[30em] ${sizeMap[size] || sizeMap["lg"]} ${className}`}
      >
        {/* Close Button */}
        {onClose && (
          <div className="flex justify-end p-2">
            <button
              onClick={onClose}
              className={`text-gray-300 hover:text-gray-300 ${noBorder ? "" : ""} p-1`}
            >
              <CloseIcon style={{ fontSize: 20 }} />
            </button>
          </div>
        )}

        {/* Header */}
        {!noHeader && (
          <div
            className={`text-lg font-semibold px-6 py-3 ${
              noBorder ? "" : "border-b border-gray-200"
            }`}
          >
            {title}
          </div>
        )}

        {/* Body */}
        <div className="" style={bodyStyleObject}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default KeypadCallModal;
